import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-foreground-950 pt-20 pb-8">
      <div className="w-full px-6 md:px-10">
        {/* Upper area - 3 columns */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-16">
          {/* Left - Brand */}
          <div>
            <h3 className="text-5xl md:text-6xl font-bold text-white mb-8">
              {t('footer.brand', 'itaobuy')}
            </h3>
            <p className="text-white/60 text-sm leading-relaxed max-w-xs">
              {t('footer.description')}
            </p>
            {/* Social icons */}
            <div className="flex gap-4 mt-8">
              {['ri-twitter-x-line', 'ri-linkedin-line', 'ri-instagram-line', 'ri-youtube-line'].map((icon) => (
                <a
                  key={icon}
                  href="#"
                  className="w-9 h-9 rounded-full border border-white/20 flex items-center justify-center text-white/40 hover:text-white hover:border-white/40 transition-colors duration-200 cursor-pointer"
                >
                  <i className={`${icon} text-sm`}></i>
                </a>
              ))}
            </div>
          </div>

          {/* Middle - Contact Info */}
          <div className="flex flex-col gap-8">
            <div>
              <p className="text-white/40 text-xs font-medium uppercase tracking-wider mb-2">Address</p>
              <p className="text-white/70 text-sm leading-relaxed">
                {t('footer.address_line1', '123 Commerce Street')}
                <br />
                {t('footer.address_line2', 'Suite 456, Business District')}
              </p>
            </div>
            <div>
              <p className="text-white/40 text-xs font-medium uppercase tracking-wider mb-2">Phone</p>
              <p className="text-white/70 text-sm">{t('footer.phone', '+1 (555) 123-4567')}</p>
            </div>
            <div>
              <p className="text-white/40 text-xs font-medium uppercase tracking-wider mb-2">Email</p>
              <p className="text-white/70 text-sm">{t('footer.email', 'hello@itaobuy.boats')}</p>
            </div>
          </div>

          {/* Right - Image */}
          <div className="flex justify-start md:justify-end">
            <div className="w-60 h-80 rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Clean%20minimalist%20modern%20coworking%20space%20with%20plants%20and%20natural%20light%20laptop%20on%20shared%20wooden%20table%20creative%20warm%20atmosphere%20elegant%20simple%20professional%20workspace%20aesthetic%20with%20greenery&width=480&height=640&seq=footer-image-v2&orientation=portrait"
                alt="Workspace"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-white/10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-white/40 text-xs">
            {t('footer.copyright', '© 2026 itaobuy.boats. All rights reserved.')}
          </p>
          <div className="flex items-center gap-6">
            <a href="#" className="text-white/40 text-xs hover:text-white/70 transition-colors duration-200 whitespace-nowrap">
              {t('footer.links.privacy', 'Privacy')}
            </a>
            <a href="#" className="text-white/40 text-xs hover:text-white/70 transition-colors duration-200 whitespace-nowrap">
              {t('footer.links.terms', 'Terms')}
            </a>
            <Link to="/" className="text-white/40 text-xs hover:text-white/70 transition-colors duration-200 whitespace-nowrap">
              {t('footer.links.back_home', 'Back to Home')}
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}